package org.ssoft.common.type

@Suppress("ClassName")
sealed class DashboardMsgType(override val mask: Int, val category: DashboardCategory) : Mask {
    /** 2; cat: UNDEFINED*/
    data object UNDEFINED : DashboardMsgType(mask = 2, category = DashboardCategory.UNDEFINED)

    /** 4; cat: COMPANY*/
    data object LOW_STORAGE_MEDIA : DashboardMsgType(mask = 4, category = DashboardCategory.COMPANY)

    /** 8; cat: LOCATION */
    data object EMERGENCY_ACTIVE : DashboardMsgType(mask = 8, category = DashboardCategory.LOCATION)

    /** 16; cat: CAMPAIGN */
    data object CAMPAIGN_NO_DEVICES : DashboardMsgType(mask = 16, category = DashboardCategory.CAMPAIGN)

    /** 32; cat: CAMPAIGN */
    data object CAMPAIGN_NO_IMPRESSIONS_LIVETIME : DashboardMsgType(mask = 32, category = DashboardCategory.CAMPAIGN)

    /** 64; cat: CAMPAIGN */
    data object CAMPAIGN_NO_IMPRESSIONS_TODAY : DashboardMsgType(mask = 64, category = DashboardCategory.CAMPAIGN)

    /** 128; cat: CAMPAIGN */
    data object CAMPAIGN_NO_IMPRESSIONS_TODAY_ONE_OR_MORE_DEVICES : DashboardMsgType(mask = 128, category = DashboardCategory.CAMPAIGN)

    /** 256; cat: CAMPAIGN */
    data object CAMPAIGN_FULLFILMENT : DashboardMsgType(mask = 256, category = DashboardCategory.CAMPAIGN)

    /** 512; cat: DEVICE */
    data object DISCONNECTED : DashboardMsgType(mask = 512, category = DashboardCategory.DEVICE)
    /** 1024; cat: DEVICE */
    data object OVERHEATING : DashboardMsgType(mask = 1024, category = DashboardCategory.DEVICE)
    /** 2048; cat: DEVICE */
    data object LOW_STORAGE_DEVICE : DashboardMsgType(mask = 2048, category = DashboardCategory.DEVICE)
    /** 4096; cat: DEVICE */
    data object NO_CAMPAIGNS : DashboardMsgType(mask = 4096, category = DashboardCategory.DEVICE)
    /** 8192; cat: DEVICE */
    data object NO_APPS : DashboardMsgType(mask = 8192, category = DashboardCategory.DEVICE)
    /** 16384; cat: DEVICE */
    data object UPDATE_REQUIRED : DashboardMsgType(mask = 16384, category = DashboardCategory.DEVICE)
    /** 32768; cat: DEVICE */
    data object CAMPAIGN_WITHOUT_IMPRESSIONS : DashboardMsgType(mask = 32768, category = DashboardCategory.DEVICE)
    /** 65536; cat: DEVICE */
    data object DISPLAY_OFF : DashboardMsgType(mask = 65536, category = DashboardCategory.DEVICE)


    companion object {
        val all by lazy {
            listOf(
                UNDEFINED,
                LOW_STORAGE_MEDIA,
                EMERGENCY_ACTIVE,

                CAMPAIGN_NO_DEVICES,
                CAMPAIGN_NO_IMPRESSIONS_LIVETIME,
                CAMPAIGN_NO_IMPRESSIONS_TODAY,
                CAMPAIGN_NO_IMPRESSIONS_TODAY_ONE_OR_MORE_DEVICES,
                CAMPAIGN_FULLFILMENT,

                DISCONNECTED,
                OVERHEATING,
                LOW_STORAGE_DEVICE,
                NO_CAMPAIGNS,
                NO_APPS,
                UPDATE_REQUIRED,
                CAMPAIGN_WITHOUT_IMPRESSIONS,
                DISPLAY_OFF
            )
        }

        operator fun get(mask: Int): DashboardMsgType = Mask[mask, all] ?: UNDEFINED

    }
}